/*
 * Created on Thu Dec 19 2019
 *
 * Copyright (c) 2019 Primas Group
 * Create by Gia Nguyen
 */

import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, tap, map, takeUntil } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { ActivationEnd, Router } from '@angular/router';
import { CancelRequestService } from './shared/services/cancel-request.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private inj: Injector, private toast: NbToastrService, private router: Router, private cancelRequestService: CancelRequestService) {
        router.events.subscribe(event => {
            // An event triggered at the end of the activation part of the Resolve phase of routing.
            if (event instanceof ActivationEnd) {
                // Cancel pending calls
                //   this.cancelRequestService.cancelPendingRequests();
            }
        });
    }
    // tslint:disable-next-line: max-line-length
    intercept(req: import('@angular/common/http').HttpRequest<any>, next: import('@angular/common/http').HttpHandler): import('rxjs').Observable<import('@angular/common/http').HttpEvent<any>> {
      const customReq = req.clone({ headers: req.headers.set("CurrentRoute", window.location.pathname) });

        return next.handle(customReq).pipe(
            // Add instance services to drop all pending requests:
            takeUntil(this.cancelRequestService.onCancelPendingRequests()),
            tap((event: HttpResponse<any>) => {
                //status code 200
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.message) {
                        setTimeout(() => {
                            this.toast.danger(event.body.message, 'Error');
                        }, 1000);
                    }
                }
            }),
            catchError(error => {
                console.log(error);
                if (error.status === 401 || error.status === 0) {
                    if (error.status === 404 || error.status === 401) {
                        this.router.navigate([`/auth`]);
                        setTimeout(() => {
                            this.toast.danger(error.status == 401 ? 'Your username or password is incorrect. Please try again' : 'Sorry, the system has an unexpected technical issue.', 'Error');
                        }, 1000);
                        return throwError(error.statusText);
                    } else {
                        setTimeout(() => {
                            this.toast.danger('Sorry, the system has an unexpected technical issue.', 'Error');
                        }, 1000);
                        return throwError(error.statusText);
                    }

                }
                if (error.status === 501) {
                    this.router.navigate([`/auth`]);
                    setTimeout(() => {
                        this.toast.danger('Your session has expired. Please log in again.', 'Error');
                    }, 1000);
                    return throwError(error.statusText);
                }
                if (error.status === 302) {
                  this.router.navigate([`/expired`]);
                  return;
                }
                if (error instanceof HttpErrorResponse) {

                    const applicationError = error.headers.get('Application-Error');
                    if (applicationError) {
                        setTimeout(() => {
                            this.toast.danger(applicationError, 'Error');
                        }, 1000);
                        return throwError(applicationError);
                    }

                    const serverError = error.error;
                    let modelStateError = '';
                    if (serverError && typeof serverError === 'object') {
                        if (!serverError.success) {
                            modelStateError = serverError.message == null ? '' : serverError.message;
                            if (typeof serverError.errors === 'object') {
                                for (const key in serverError.errors) {
                                    if (serverError.errors[key]) {
                                        modelStateError += serverError.errors[key] + '\n';
                                    }
                                }
                            }
                        }
                    }
                    setTimeout(() => {
                        this.toast.danger(modelStateError || 'Server Error', 'Error');
                    }, 1000);
                    return throwError(modelStateError || 'Server Error');
                }
            }));

    }

}
